// extracted by mini-css-extract-plugin
export var project = "FeaturedProject-module--project--100G-";
export var project__icon = "FeaturedProject-module--project__icon--3W9vu";
export var projectFeatured = "FeaturedProject-module--project--featured--2ua2J";
export var project__categories = "FeaturedProject-module--project__categories--2iC2_";
export var project__name = "FeaturedProject-module--project__name--xTzhI";
export var project__category = "FeaturedProject-module--project__category--xZfq4";
export var project__content = "FeaturedProject-module--project__content--3ANjD";
export var project__hover = "FeaturedProject-module--project__hover--1YYQL";